export const HEADER_BLOCK = Object.freeze({
  ONE: 'header-one',
  TWO: 'header-two',
  THREE: 'header-three',
  FOUR: 'header-four',
  FIVE: 'header-five',
  SIX: 'header-six',
});

export const BLOCK_TYPES = Object.freeze([
  'header-one',
  'header-two',
  'header-three',
  'header-four',
  'header-five',
  'header-six',
  'unordered-list-item',
  'ordered-list-item',
  'blockquote',
  'atomic',
  'code-block',
  'unstyled',
]);

export const BUTTON_TYPE = 'wix-draft-plugin-button';
export const CODE_BLOCK_TYPE = 'code-block';
export const DIVIDER_TYPE = 'wix-draft-plugin-divider';
export const EMOJI_TYPE = 'wix-draft-plugin-emoji';
export const FILE_UPLOAD_TYPE = 'wix-draft-plugin-file-upload';
export const GALLERY_TYPE = 'wix-draft-plugin-gallery';
export const GIPHY_TYPE = 'wix-draft-plugin-giphy';
export const HASHTAG_TYPE = 'wix-draft-plugin-hashtag';
export const HEADERS_MARKDOWN_TYPE = 'wix-draft-plugin-headers-markdown';
export const HTML_TYPE = 'wix-draft-plugin-html';
export const IMAGE_TYPE = 'wix-draft-plugin-image';
export const IMAGE_TYPE_LEGACY = 'IMAGE';
export const LINE_SPACING_TYPE = 'line-spacing';
export const EXTERNAL_LINK_TYPE = 'wix-draft-plugin-external-link';
export const LINK_TYPE = 'LINK';
export const LINK_PREVIEW_TYPE = 'LINK_PREVIEW';
export const MAP_TYPE = 'wix-draft-plugin-map';
export const EXTERNAL_MENTIONS_TYPE = 'wix-draft-plugin-external-mentions';
export const MENTION_TYPE = 'mention';
export const SOUND_CLOUD_TYPE = 'wix-draft-plugin-sound-cloud';
export const TEXT_COLOR_TYPE = 'wix-rich-content-text-color';
export const TEXT_HIGHLIGHT_TYPE = 'wix-rich-content-text-highlight';
export const VIDEO_TYPE = 'wix-draft-plugin-video';
export const VIDEO_TYPE_LEGACY = 'VIDEO-EMBED';
